import _ from 'lodash';
export const getInputProps = ($element) => {
    var _a;
    const config = $element.config;
    const details = getMeasureDetails(config.measure);
    const modeModifier = $element.blocked ? ['purple'] : [];
    const fieldProps = {
        mode: $element.defaultFieldMode === 'simple' ? ['xxs', ...modeModifier] : ['sm', ...modeModifier],
        type: config.type,
        label: config.label,
        placeholder: $element.placeholder,
        clear: config.clear,
        autoFocus: config.autoFocus,
        helpText: config.helpText,
        leftElement: config.leftElement,
        rightElement: config.rightElement,
        maxLength: config.maxLength,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        readonly: $element.isReadonly,
    };
    return {
        fieldProps,
        units: config.units || details.units,
        masks: config.masks || details.masks,
    };
};
export const getDateProps = ($element) => {
    var _a;
    const config = $element.config;
    const modeModifier = $element.blocked ? ['purple'] : [];
    const fieldProps = {
        mode: $element.defaultFieldMode === 'simple' ? ['xxs', ...modeModifier] : ['sm', ...modeModifier],
        label: config.label,
        placeholder: $element.placeholder,
        clear: config.clear,
        autoFocus: config.autoFocus,
        helpText: config.helpText,
        leftElement: config.leftElement,
        minDate: config.minDate,
        maxDate: config.maxDate,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        readonly: $element.isReadonly,
    };
    return {
        fieldProps,
    };
};
export const getDateSelectProps = ($element) => {
    var _a;
    const config = $element.config;
    const modeModifier = $element.blocked ? ['purple'] : [];
    const fieldProps = {
        mode: $element.defaultFieldMode === 'simple' ? ['xxs', ...modeModifier] : ['sm', ...modeModifier],
        label: config.label,
        isFull: config.isFull,
        minDate: config.minDate,
        maxDate: config.maxDate,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        readonly: $element.isReadonly,
    };
    return {
        fieldProps,
    };
};
export const getTextareaProps = ($element) => {
    var _a;
    const config = $element.config;
    const modeModifier = $element.blocked ? ['purple'] : [];
    const fieldProps = {
        mode: $element.defaultFieldMode === 'simple'
            ? ['transparent', 'xxs', ...modeModifier]
            : ['sm', ...modeModifier],
        label: config.label,
        placeholder: $element.placeholder,
        clear: config.clear,
        autoFocus: config.autoFocus,
        helpText: config.helpText,
        leftElement: config.leftElement,
        rightElement: config.rightElement,
        autoGrow: config.autoGrow,
        rows: config.rows,
        maxRows: config.maxRows,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        readonly: $element.isReadonly,
    };
    return {
        fieldProps,
    };
};
export const getSelectProps = ($element) => {
    var _a;
    const config = $element.config;
    const modeModifier = $element.blocked ? ['purple'] : [];
    const fieldProps = {
        mode: $element.defaultFieldMode === 'simple' ? ['xxs', ...modeModifier] : ['sm', ...modeModifier],
        label: config.label,
        placeholder: $element.placeholder,
        clear: config.clear,
        autoFocus: config.autoFocus,
        helpText: config.helpText,
        leftElement: config.leftElement,
        multi: config.multi,
        allOption: config.allowUnselect,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        readonly: $element.isReadonly,
    };
    return {
        fieldProps,
    };
};
export const getToggleButtonGroupProps = ($element, blocked) => {
    var _a;
    const config = $element.config;
    const size = $element.defaultFieldMode === 'simple' ? 'xxs' : 'sm';
    const renderOption = config.renderOption || { checkbox: { position: 'none' } };
    const fieldProps = {
        size: size,
        multi: config.multi,
        allowUnselect: config.allowUnselect,
        isExtraFieldRequired: true,
        renderOption: renderOption,
        renderOptionProps: config.subvariant === 'form' && blocked.length > 0
            ? (props) => blocked.includes(props.option.id)
                ? { mode: ['secondary-dark', size, 'purple'] }
                : {}
            : (config.subvariant === 'default' || !config.subvariant) && $element.blocked
                ? (props) => (props.isSelected ? { mode: ['secondary-dark', size, 'purple'] } : {})
                : undefined,
        className: (_a = $element.renderParams) === null || _a === void 0 ? void 0 : _a.className,
        disabled: $element.isReadonly,
    };
    return { fieldProps };
};
export function getMeasureDetails(type) {
    let units;
    let masks;
    switch (type) {
        case 'height':
            units = { foot: 'ft', inch: 'in' };
            masks = {
                foot: { mask: 'number', min: 0, max: 9.99, scale: 2, signed: false },
                inch: { mask: 'number', min: 0, max: 11.99, scale: 0, signed: false },
            };
            break;
        case 'weight':
            units = 'lbs';
            masks = { mask: 'number', min: 0, max: 1000, scale: 2, signed: false };
            break;
        case 'blood_pressure':
            units = { diastolic: 'mmHg' };
            masks = {
                systolic: { mask: 'number', min: 70, max: 370, scale: 0, signed: false },
                diastolic: { mask: 'number', min: 40, max: 360, scale: 0, signed: false },
            };
            break;
        case 'heart_rate':
            units = 'bpm';
            masks = { mask: 'number', min: 30, max: 250, scale: 0, signed: false };
            break;
        case 'spo2':
            units = '%';
            masks = { mask: 'number', min: 50, max: 100, scale: 0, signed: false };
            break;
        case 'body_temperature':
            units = '°F';
            masks = { mask: 'number', min: 50, max: 120, scale: 2, signed: false };
            break;
        case 'hemoglobin_a1c':
            units = '%';
            masks = { mask: 'number', min: 2, max: 20, scale: 2, signed: false };
            break;
        case 'glucose_blood_sugar_level':
            units = 'mg/dL';
            masks = { mask: 'number', min: 30, max: 1000, scale: 0, signed: false };
            break;
        case 'respiratory_rate':
            units = 'bpm';
            masks = { mask: 'number', min: 5, max: 80, scale: 0, signed: false };
            break;
    }
    return { units, masks };
}
export function getDefaultValue(...args) {
    for (const type of args) {
        if (type === 'string')
            return '';
        if (type === 'array')
            return [];
        if (type === 'object')
            return {};
        if (_.isPlainObject(type))
            return type;
    }
    return '';
}
